export default {
  mask: 'Mask',
  onlyOneTip: 'Only one mask component can be added within the same scene.',
  maskComponent: 'Mask Component',
  maskSetting: 'Mask Settings',
  isEnable: 'Enable Component',
  enableText: 'Enabled',
  disableText: 'Disabled',
  addMaskGroup: 'Create Mask Group',
  layer: {
    maskGroup: 'Mask Group',
    maskedGroup: 'Masking Group',
    maskShapeGroup: 'Mask Shape',
    maskShape: 'Shape',
    followGroup: 'Follow Element',
  },
  maskGroup: {
    enableTip:
      'After disabling, the events of all layers under this mask group will be disabled.',
    maskShape: 'Mask Shape',
    maskShapeTip:
      'After disabling, the mask shape and the followed element will be hidden, and there will be no masking effect.',
    shape: 'Shape',
    rect: 'Rectangle',
    round: 'Circle',
    preview: 'Preview Mask Effect',
    cancelPreview: 'Cancel Preview',
    followElement: 'Follow Element',
    followElementTip:
      'After setting the follow element, you need to add drag events to the shape. Once set, the follow element will track the drag movement of the shape.',
    addSubGroupDialog: {
      title: 'Add Group',
      groupName: 'Group Name',
      groupNamePlaceholder: 'Please enter the group name.',
      groupNameEmptyWarning: 'Cannot be empty',
    },
    maskSubGroupCanMaskTip:
      'The image inside the mask group will be visible within the covered area of the mask shape and hidden outside the covered area.',
    maskSubGroupCanNotMaskTip: 'This group will not be masked.',
  },
}
